import "./article.scss";
import { ISiteContentResponseModel } from "../../core/models";

export interface IArticleMainProps {
  content: ISiteContentResponseModel;
}

const ArticleMain = ({ content }: IArticleMainProps) => {
  return (
    <article className="article-main">
      <div className="article-main__text">
        {content.title && (
          <h3 className="article-main__text-title">{content.title}</h3>
        )}

        {content.text && (
          <p
            className="article-main__text-description"
            dangerouslySetInnerHTML={{ __html: content.text }}
          ></p>
        )}

        {content.image && (
          <div className="article-main__image">
            <img
              src={content.image?.src}
              width={343}
              height={200}
              alt={content.image?.alt}
              style={{ height: "auto", width: "100%" }}
            />
            {content.image?.alt && (
              <span className="aticle-main__image-description">
                {content.image.alt}
              </span>
            )}
          </div>
        )}
      </div>
    </article>
  );
};

export default ArticleMain;
